import React from "react";
import { trans } from "../../helpers/index";
import config from "../../baseConfig/index";

export default (translationData) => {
  return (
    <>
      <div className="main-wrapper__right pa scroller-block">
        <div className="table">
          <div className="table-cell">
            <div className="main-wrapper__right-inner">
              <div className="main-wrapper__title-out">
                <h2 className="main-wrapper__title monserrat-medium tc tu fs63">
                  {trans(translationData.trans, "auth.title")}
                </h2>

                <div className="main-wrapper__img-out clear-fix tr">
                  <div className="main-wrapper__store-box dib">
                    <div className="main-wrapper__store-inner">
                      <a
                        className="main-wrapper__store-icon main-wrapper__store-icon--app-store sprite db"
                        href={trans(translationData.trans, "app.ios.url")}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        &nbsp;
                      </a>
                      <a
                        className="main-wrapper__store-icon main-wrapper__store-icon--play-market sprite db"
                        href={trans(translationData.trans, "app.android.url")}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        &nbsp;
                      </a>
                    </div>
                  </div>
                  <div className="main-wrapper__img-box dib">
                    <img
                      className="main-wrapper__img"
                      src={`${config.imgURLPrefix}img/mobile-devices.png?v=3`}
                      alt={trans(translationData.trans, "auth.title")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="main-wrapper__bottom-group">
        <div className="main-wrapper__bottom-block clear-fix">
          <ul className="social fl">
            <li className="social__item ver-top-box">
              <a
                className="social__icon social__icon--fb db sprite sprite-b pr"
                href={trans(
                  translationData.trans,
                  "auth.social.facebook.anchor"
                )}
                rel="noopener noreferrer"
                target="_blank"
              >
                &nbsp;
              </a>
            </li>
            <li className="social__item ver-top-box">
              <a
                className="social__icon social__icon--in db sprite sprite-b pr"
                href={trans(
                  translationData.trans,
                  "auth.social.facebook.instagram.anchor"
                )}
                rel="noopener noreferrer"
                target="_blank"
              >
                &nbsp;
              </a>
            </li>
            <li className="social__item ver-top-box">
              <a
                className="social__icon social__icon--ok db sprite sprite-b pr"
                href={trans(
                  translationData.trans,
                  "auth.social.facebook.ok.anchor"
                )}
                rel="noopener noreferrer"
                target="_blank"
              >
                &nbsp;
              </a>
            </li>
            <li className="social__item ver-top-box">
              <a
                className="social__icon social__icon--youtube db sprite sprite-b pr"
                href={trans(
                  translationData.trans,
                  "auth.social.facebook.youtube.anchor"
                )}
                rel="noopener noreferrer"
                target="_blank"
              >
                &nbsp;
              </a>
            </li>
            <li className="social__item ver-top-box">
              <a
                className="social__icon social__icon--twitter db sprite sprite-b pr"
                href={trans(
                  translationData.trans,
                  "auth.social.facebook.twitter.anchor"
                )}
                rel="noopener noreferrer"
                target="_blank"
              >
                &nbsp;
              </a>
            </li>
          </ul>
          <p
            className="main-wrapper__bottom-txt fr fs14"
            dangerouslySetInnerHTML={{
              __html: trans(
                translationData.trans,
                "auth.copyright.text"
              ).replace(/%s/, new Date().getFullYear()),
            }}
          />
        </div>
      </div>
    </>
  );
};
